<template>
  <div>
    <a-descriptions title="用户信息">
      <a-descriptions-item label="用户名">
        {{ this.userInfo.uccode }}
      </a-descriptions-item>
      <a-descriptions-item label="邮箱">
        {{ this.userInfo.email }}
      </a-descriptions-item>
      <a-descriptions-item label="手机号码">
        {{ this.userInfo.phone }}
      </a-descriptions-item>

    </a-descriptions>
    <a-button @click="changePhone" style="font-size: 15px;width: 150px;background-color: #014298" type="primary">
      更换手机号
    </a-button>
    <a-modal
        title="更换手机号"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel">
      <a-form :form="form" class="user-layout-login" ref="formPhone" id="formPhone">
        <a-form-item label="新手机号" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
          <a-input
              v-decorator="['mobile',{initialValue:'', rules:validatorRules.mobile.rules}]"
              size="large"
              type="text"
              placeholder="新手机号">
            <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input>
        </a-form-item>
        <a-row :gutter="0" v-if="showCode">
          <a-col :span="15">
            <a-form-item label="图形验证码" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input
                  v-decorator="['inputCode2',validatorRules.inputCode]"
                  size="large"
                  type="text"
                  @change="inputCodeChange"
                  placeholder="请输入图形验证码">
                <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6" style="text-align: right">
            <img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="randCodeImage"
                 @click="handleChangeCheckCode"/>
            <img v-else style="margin-top: 2px;" src="../../assets/checkcode.png" @click="handleChangeCheckCode"/>
          </a-col>
        </a-row>
        <a-row :gutter="0">
          <a-col class="gutter-row" :span="15">
            <a-form-item label="短信验证码" :label-col="{ span: 8 }" :wrapper-col="{ span: 15 }">
              <a-input
                  v-decorator="['captcha',{initialValue:'', rules:validatorRules.captcha.rules}]"
                  size="large"
                  type="text"
                  placeholder="请输入短信验证码">
                <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="8">
            <a-button
                class="getCaptcha"
                tabindex="-1"
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCaptcha"
                v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')"></a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import {getAction, postAction} from "@/api/manage";

export default {
  name: "UserInfo",
  data() {
    return {
      userInfo: {},
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        mobile: {rules: [{required: true, message: '请输入正确手机号!', validator: this.validateMobile}]},
        captcha: {rules: [{required: true, message: '请输入短信验证码!'}]},
        inputCode: {rules: [{required: true, message: '请输入验证码!'}]}
      },
      showCode: false,
      inputCodeContent: '',
      randCodeImage: '',
      requestCodeSuccess: false,
      currdatetime: '',
      state: {
        time: 60,
        smsSendBtn: false,
      },
    }
  },
  created() {
    this.queryUserInfo();
    this.handleChangeCheckCode();
  },
  methods: {
    queryUserInfo() {
      getAction('/user/queryById').then(res => {
        if (res.success) {
          this.userInfo = res.data;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changePhone() {
      this.visible = true;
    },
    handleOk(e) {
      this.confirmLoading = true;
      let that = this
      let params = {};
      that.form.validateFields((err, values) => {
        if (!err) {
          params.mobile = values.mobile;
          params.captcha = values.inputCode2;
          params.smsCode = values.captcha;
          params.checkKey = this.currdatetime;
          postAction('/user/changePhone', params).then((res) => {
            if (res.success) {
              this.$message.success('手机号码更换成功!')
              this.handleCancel();
              this.queryUserInfo();
            } else {
              this.confirmLoading = false;
              this.$message.warning(res.message)
            }
          });
        } else {
          this.confirmLoading = false;
        }
      })

    },
    handleCancel(e) {
      console.log('Clicked cancel button');
      this.visible = false;
      this.form.resetFields();
      this.showCode = false;
      this.confirmLoading = false;
    },
    validateMobile(rule, value, callback) {
      if (!value) {
        this.showCode = false;
        callback("请输入手机号!");
      } else if (!new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
        this.showCode = false;
        callback("手机号码格式不正确!");
      } else {
        //显示图片验证码
        this.showCode = true;
        callback();
      }

    },
    inputCodeChange(e) {
      this.inputCodeContent = e.target.value
    },
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime();
      getAction(`/user/randomImage/${this.currdatetime}`).then(res => {
        if (res.success) {
          this.randCodeImage = res.data.imgCode
          this.requestCodeSuccess = true
        } else {
          this.$message.error(res.message)
          this.requestCodeSuccess = false
        }
      }).catch(() => {
        this.requestCodeSuccess = false
      })
    },
    getCaptcha(e) {
      e.preventDefault();
      let that = this;
      this.form.validateFields(['mobile', 'inputCode2'], {force: true}, (err, values) => {
            if (!values.mobile) {
              this.$message.error("请输入手机号！");
            } else if (!values.inputCode2) {
              this.$message.error("请输入图形验证码！");
            } else if (!err) {
              this.state.smsSendBtn = true;
              let interval = window.setInterval(() => {
                if (that.state.time-- <= 0) {
                  that.state.time = 60;
                  that.state.smsSendBtn = false;
                  window.clearInterval(interval);
                }
              }, 1000);

              let smsParams = {};
              smsParams.mobile = values.mobile;
              smsParams.checkKey = that.currdatetime;
              smsParams.inputCode = values.inputCode2;
              postAction("/user/sendSms", smsParams)
                  .then(res => {
                    if (!res.success) {
                      clearInterval(interval);
                      this.$message.error(res.message);
                      that.state.time = 60;
                      that.state.smsSendBtn = false;
                    } else {
                      this.$message.success('验证码发送成功');
                    }

                  })
                  .catch(err => {
                    clearInterval(interval);
                    that.state.time = 60;
                    that.state.smsSendBtn = false;
                    this.$message.error(err)
                  });
            }
          }
      );
    },
  }
}
</script>

<style scoped>
.getCaptcha {
  display: block;
  width: 75%;
  height: 40px;
}
</style>
